import { render, staticRenderFns } from "./TaskSelector.vue?vue&type=template&id=2d82f01b&scoped=true"
import script from "./TaskSelector.vue?vue&type=script&lang=js"
export * from "./TaskSelector.vue?vue&type=script&lang=js"
import style0 from "./TaskSelector.vue?vue&type=style&index=0&id=2d82f01b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d82f01b",
  null
  
)

export default component.exports